module.exports = __webpack_public_path__ + "images/rich_heading/brand/bg_a709727288dc1ed45185b490637a7be1.png";